/* ---------------------------------------------------------------------------------------------------------------------
   TSC RIDER TYPES

   Opens one rider persona at a time. Tapping the open card closes it, so a visitor can always get back to the full row.
   --------------------------------------------------------------------------------------------------------------------- */

(function () {
  function initRiderTypes(root) {
    // Sections are re-rendered in the theme editor, and the two entry points below can both reach the same element.
    if (root.dataset.tscRidersReady === "true") return;
    root.dataset.tscRidersReady = "true";

    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-rider-card]"));
    if (cards.length === 0) return;

    function setOpen(card, open) {
      var toggle = card.querySelector("[data-rider-toggle]");
      var panel = card.querySelector(
        '[id="' + (toggle ? toggle.getAttribute("aria-controls") : "") + '"]',
      );

      card.classList.toggle("is-open", open);
      if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (panel) panel.hidden = !open;
    }

    cards.forEach(function (card) {
      var toggle = card.querySelector("[data-rider-toggle]");
      if (!toggle) return;

      toggle.addEventListener("click", function () {
        var willOpen = !card.classList.contains("is-open");

        // One answer at a time: opening a card closes whichever one was already open.
        cards.forEach(function (other) {
          setOpen(other, other === card && willOpen);
        });
      });
    });
  }

  function initAll(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    target.querySelectorAll(".js-tsc-rider-types").forEach(initRiderTypes);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
